<template>
    <b-standard-card
        :title="translations.title[lang]"
        :loading="loading"
        :error-message="errorMessage"
        :disabled="!formValid"
        @submit="getCashRegisters"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :hideDefaultFooter="true"
    >
      <v-toolbar flat height="90">
            <v-btn
                color="secondary"
                class="text-capitalize px-5"
                depressed
                v-text="translations.addNew[lang] + ' ' + translations.formtitle[lang]"
                @click="openModal('create', {})"
            ></v-btn>

            <v-spacer></v-spacer>

            <!-- <v-col cols="4" class="pa-0">
                <b-search-field
                    v-model="search"
                    :selectedSearchType="selectedSearchType"
                    :searchTypes="searchTypes"
                ></b-search-field>
            </v-col> -->
        </v-toolbar>

      <v-data-table
      v-if="cashRegisters&&cashRegisters.length"
            :headers="headers"
            :items="cashRegisters"
            :footer-props="{
                itemsPerPageOptions: [cashRegistersPagination.items_per_page],
                showCurrentPage: true,
                pageText: `${page * 12 - 11}-${
                    page * 12 <= cashRegistersPagination.total
                        ? page * 12
                        : cashRegistersPagination.total
                } ${translations.paginationText[lang]} ${cashRegistersPagination.total}`,
            }"
            :page.sync="page"
            :server-items-length="cashRegistersPagination.total"
            :loading="loading"
            disable-sort
            class="b-outlined"
        >
            <!-- <template v-slot:item.image="{ item }">
                <v-img :src="item.image" width="70" v-if="item.image"></v-img>
                <div v-else>-</div>
            </template> -->
            <template v-slot:no-data>
                <span
                    v-if="!loading"
                    v-text="translations.noData[lang]"
                ></span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="yellow darken-3"
                            icon
                            v-on="on"
                            @click="openModal('update', item)"
                        >
                            <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.edit[lang]"
                    ></span>
                </v-tooltip>

                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="red"
                            icon
                            v-on="on"                            
                            @click="openModal('delete', item)"

                        >
                            <v-icon v-text="icons.mdiClose"></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.delete[lang]"
                    ></span>
                </v-tooltip>
            </template>
        </v-data-table>

         <v-dialog v-model="dialog" max-width="600">
            <CashRegisterForm :mode="mode" :item="item" @cancel="closeModal"  @close="closeModal"/>
        </v-dialog>

    </b-standard-card>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import translations from "@/utils/translations/storePanel/settings/profile/cashRegisters";
import validators from "@/utils/validators/storePanel/cashRegisters";
import CashRegisterForm from "@/components/storePanel/settings/profile/CashRegisterDialog.vue";
import { mdiPencilOutline, mdiClose } from "@mdi/js";

export default {
    name: "CashRegisters",

    mixins: [translations, validators],

    components: { CashRegisterForm },

    data: () => ({
      icons: { mdiPencilOutline, mdiClose },
      page:1,
      cash_register:{},
      dialog: false,
      mode:'create',
      item: {}
    //   item:{}
    }),
    mounted() {
        this.getCashRegisters()
    },

    computed: {
        ...mapState("storePanel/profile",["cashRegisters","cashRegistersPagination", "loading","errorMessage"]),
        lang() {
            return this.$route.params.lang;
        },

        loading() {
            return this.$store.state.storePanel.profile.loading.cashRegisters;
        },

        errorMessage() {
            return this.$store.state.storePanel.profile.errorMessage
                .cashRegisters;
        },

        resetSuccess() {
            return this.$store.state.storePanel.profile.resetSuccess
                .cashRegisters;
        },
        
        headers() {
            return [
                // {
                //     text: 'this.translations.image[this.lang]',
                //     value: "image",
                // },
                {
                    text: this.translations.friendlyName[this.lang],
                    value: `friendly_name`,
                },
                {
                    text: this.translations.code[this.lang],
                    value: `cash_register_code`,
                },
             
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                },
            ];
        },
    },

    methods: {
        // ...mapMutations("storePanel/profile", ["setResetSuccess"]),
        ...mapActions("storePanel/profile", ["getCashRegisters", "createCashRegister", "updateCashRegister", "deleteCashRegister"]),
        
        openModal(mode, item) {
            this.item=item
            this.mode = mode;
            this.cash_register = item;
            this.dialog = true;
        },
        closeModal(){
            this.item = {}
            this.dialog = false;
            // this.resetSuccess
        }
    },
};
</script>
